var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "alert flex items-center",
    class: [_vm.type ? 'alert-' + _vm.type : '', _vm.colorString ? 'alert-' + _vm.colorString : '', _vm.spaced ? 'py-24 px-16' : 'p-16', {
      'mb-8 sm:mb-16': !_vm.noSpacing
    }, _vm.responsiveGridBorderRadiusClass, _vm.shadowString ? 'shadow-' + _vm.shadowString : '', {
      'alert-text': _vm.text,
      'text-white': !!_vm.colorHex
    }],
    style: {
      backgroundColor: _vm.colorHex
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "flex w-full"
  }, [_vm.displayIcon ? _c('div', {
    staticClass: "p-8 relative mr-24",
    class: {
      'none sm:block': _vm.hideIconOnMobile
    }
  }, [_c('icon', {
    attrs: {
      "icon": _vm.displayIcon,
      "prominent": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "alert__content flex flex-column justify-center flex-grow-x-1",
    class: {
      'sm:flex-row sm:items-center sm:justify-between': !_vm.vertical
    }
  }, [_vm.content ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm.button ? _c('btn', {
    staticClass: "mt-16 w-full min-w-200",
    class: {
      'sm:mt-0 sm:ml-16 sm:w-auto': !_vm.vertical
    },
    attrs: {
      "to": _vm.to,
      "color": _vm.type ? ((_vm.type) + " lighten") : 'success'
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm.buttonIcon ? _c('icon', {
    attrs: {
      "icon": _vm.buttonIcon
    }
  }) : _vm.button === true ? _c('icon', {
    attrs: {
      "icon": _vm.$icons.create
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.button === true ? this.$trans('action.add', 'Hinzufügen') : _vm.button))])], 1) : _vm._e()], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }